(function () {
  'use strict';

  var STORAGE_KEY = 'dubarry_wishlist';

  var DubarryWishlist = window.DubarryWishlist = {
    get: function () {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
      catch (e) { return []; }
    },

    _save: function (items) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      window.dispatchEvent(new CustomEvent('wishlist:change', { detail: { count: items.length } }));
    },

    add: function (item) {
      var items = this.get();
      var idx = items.findIndex(function (i) { return String(i.variantId) === String(item.variantId); });
      if (idx === -1) { items.push(item); } else { items[idx] = item; }
      this._save(items);
    },

    remove: function (variantId) {
      this._save(this.get().filter(function (i) { return String(i.variantId) !== String(variantId); }));
    },

    has: function (variantId) {
      return this.get().some(function (i) { return String(i.variantId) === String(variantId); });
    },

    count: function () { return this.get().length; },

    formatMoney: function (cents) {
      return '$' + Math.ceil(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  };

  function updateBadges(count) {
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  window.addEventListener('wishlist:change', function (e) { updateBadges(e.detail.count); });
  document.addEventListener('DOMContentLoaded', function () { updateBadges(DubarryWishlist.count()); });
})();
